import request from "@/utils/request"

//充值余额
export function Send_FeeTable_BalanceRecharge(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/BalanceRecharge",
    method: "get",
    params
  })
}

//强制对齐余额
export function Send_FeeTable_BalanceForceDq(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/BalanceForceDq",
    method: "get",
    params
  })
}
//查询费控表余额
export function Send_FeeTable_QueryDevBalance(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/SendQueryDevBalance",
    method: "get",
    params
  })
}

//平台查询sim卡信息
export function Send_QuerySim(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/SendQuerySim",
    method: "get",
    params
  })
}
//平台招离线（分支箱）
export function Send_BranchBox_CallOfflineOrder(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/BranchBox_CallOfflineOrder",
    method: "get",
    params
  })
}
//设备重启
export function Send_DevRestart(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/SendDevRestart",
    method: "get",
    params
  })
}
